import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ApiClient from '@/plugins/api-client'
// import Vant from 'vant';
import { Button,Toast,Icon,Swipe,SwipeItem,Field,CellGroup,Picker,Popup,Switch,
  Form,Uploader,RollingText,Calendar,ImagePreview,CountDown,Dialog,Overlay, Checkbox,
  RadioGroup, Radio, DatePicker,Circle } from 'vant';
import 'vant/lib/index.css';
import '@/assets/styles/index.scss'

import {removeToken,removeMarsToken} from '@/utils/auth'
import userServices from '@/services/user'

console.log('process', process.env)

const { logout } = userServices;
// 检查版本变化
const currentVersion = process.env.VUE_APP_VERSION
const lastVersion = localStorage.getItem('app_version')
console.log('lastVersion', lastVersion)
console.log('currentVersion', currentVersion)
if (!lastVersion || lastVersion !== currentVersion) {
  // 版本变化时清除缓存
  if ('caches' in window) {
    caches.keys().then(cacheNames => {
      cacheNames.forEach(cacheName => caches.delete(cacheName))
    })
  }
  removeToken()
  removeMarsToken()
  deleteAllCookies()
  logout()
  
  localStorage.setItem('app_version', currentVersion)
}



function deleteAllCookies() {
    const cookies = document.cookie.split(';');
    const domain = window.location.hostname; // 获取当前域名

    cookies.forEach(cookie => {
        const cookieName = cookie.split('=')[0].trim();
        document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${domain};`;
        document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=.${domain};`;
    });

    console.log('All cookies have been deleted.');
}



createApp(App)
.use(router).use(store)
.use(ApiClient)
.use(Button).use(Toast).use(Icon).use(Swipe).use(SwipeItem).use(Field).use(CellGroup).use(Picker).use(Popup).use(Switch)
.use(Form).use(Uploader).use(RollingText).use(Calendar).use(ImagePreview).use(CountDown).use(Dialog).use(Overlay).use(Checkbox)
.use(Radio).use(RadioGroup).use(DatePicker).use(Circle)
.mount('#app')
